import constants from "../constants";
import { weapons } from "../web3/SFM-WeaponConstants";
export const WeaponsData = [
  {
    name: 'Primary weapon',
    type: 'Weapon',
    description: constants.Primary_weapon,
    price:"$6,00",
    image:"https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQQKjiBZ3LVHcHgLmuvc8QyCn1WpNMPQxxcsvwMGohoDK/weapons/Primary%20weapon.gif",
    category:weapons.primaryWeapon
  },
  {
    name: 'Plasma Gun',
    type: 'Weapon',
    description: constants.plasma_Gun,
    price:"$7,00",
    image:"https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQQKjiBZ3LVHcHgLmuvc8QyCn1WpNMPQxxcsvwMGohoDK/weapons/plasma%20Gun.gif",
    category:weapons.plasmaBall
  },
  {
    name: 'Rocket Launcher',
    type: 'Weapon',
    description: constants.rocket_launcher,
    price:"$9,00",
    image:"https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQQKjiBZ3LVHcHgLmuvc8QyCn1WpNMPQxxcsvwMGohoDK/weapons/rocket%20launcher.gif",
    category:weapons.rocketLauncher
  },
  {
    name: 'Plasma Ball',
    type: 'Weapon',
    description: constants.Plasma_Ball,
    price:"$11,00",
    image:"https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQQKjiBZ3LVHcHgLmuvc8QyCn1WpNMPQxxcsvwMGohoDK/weapons/Plasma%20Ball.gif",
    category:weapons.plasmaBall
  },
  {
    name: 'Blaster Gun',
    type: 'Weapon',
    description: constants.blaster_gun,
    price:"$9,50",
    image:"https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQQKjiBZ3LVHcHgLmuvc8QyCn1WpNMPQxxcsvwMGohoDK/weapons/blaster%20gun.gif",
    category:weapons.blasterGun
  },
  {
    name: 'Machine Gun',
    type: 'Weapon',
    description: constants.Machine_Gun,
    price:"$13,00",
    image:"https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQQKjiBZ3LVHcHgLmuvc8QyCn1WpNMPQxxcsvwMGohoDK/weapons/Machine%20Gun.gif",
    category:weapons.machineGun
  },
  {
    name: 'Laser',
    type: 'Weapon',
    description: constants.Laser,
    price:"$7,00",
    image:"https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQQKjiBZ3LVHcHgLmuvc8QyCn1WpNMPQxxcsvwMGohoDK/weapons/Laser.gif",
    category:weapons.laser
  }
];
